import { render, staticRenderFns } from "./Masa.vue?vue&type=template&id=e6d28b7a&scoped=true&"
import script from "./Masa.vue?vue&type=script&lang=js&"
export * from "./Masa.vue?vue&type=script&lang=js&"
import style0 from "./Masa.vue?vue&type=style&index=0&id=e6d28b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d28b7a",
  null
  
)

export default component.exports